import ProgressCircle from '../../elements/progress-circle'

const LoadingState = ({ label }) => (
  <div sx={{ display: 'flex', justifyContent: 'center' }}>
    <div
      sx={{
        textAlign: 'center',
        paddingTop: 'lg',
        paddingBottom: 'xxl',
        paddingX: 'xxl',
        backgroundColor: 'grey-0',
      }}
    >
      <h3 sx={{ paddingBottom: 'xxl' }}>{label}</h3>
      <ProgressCircle />
    </div>
  </div>
)

export default LoadingState
